import { Heading, Text } from '@chakra-ui/react';

import COUNTRIES from './constants/countries';
import { CRITICS, VINTAGES_INFO } from './constants/ratings';

const countryName = (name) => name.replace(/[^\w\s.,/&'-]/g, '').trim();

function subregionNames(country) {
  return country.regions
    .flatMap((region) => region.subregions)
    .map((subregion) => subregion.name)
    .join(', ');
}

function SEOContent() {
  return (
    <section className="seo-content" aria-labelledby="wine-vintage-chart-coverage">
      <Heading as="h2" id="wine-vintage-chart-coverage">
        Browse wine vintage ratings by country and region
      </Heading>
      <Text>
        Chart.vin covers vintage years from {VINTAGES_INFO.min} through {VINTAGES_INFO.max} where
        ratings are available. Use the average chart for a quick overview, or switch critic tabs to
        compare individual wine vintage ratings.
      </Text>
      <Text marginTop={3}>
        Available views include average ratings and critic-specific charts for {CRITICS.join(', ')}.
        The table is organized by country, wine region, subregion, and vintage year.
      </Text>
      <div className="seo-region-grid">
        {COUNTRIES.map((country) => (
          <article className="seo-region-item" key={country.key}>
            <Heading as="h3">{countryName(country.name)} vintage chart</Heading>
            <Text>{subregionNames(country)}</Text>
          </article>
        ))}
      </div>
    </section>
  );
}

export default SEOContent;
